<template>
  <div class="side-bar-main">
    <ul class="nav-main">
      <li v-for="item in data" :key="item.id" class="nav-item" :item="item">
        <span class="text" @click="navigation(item.id,item)">{{ item.name }}</span>
        <ul v-if="item.columnList" class="chidren-box">
          <li v-for="(chidren,index) in item.columnList" :key="index" class="chidren-item text" @click="goInterLink(chidren)">
            <a href="#">
              <span>{{ chidren.name }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

  props: {
    data: {
      type: Array,
      default: function() {
        return []
      }
    },
    activeMenu: {
      type: String,
      default: ''
    }
  },
  methods: {
    navigation(id, item) {
      try {
        if (id === 999) {
          this.$router.push({
            path: '/'
          })
        } else {
          // 文本导航
          if (item.navigationType) {
            if (item.jumpUrl) window.location.href = item.jumpUrl;
          } else {
            this.$router.push({
              path: '/subPage',
              query: {
                name: item.name
              }
            })
          }
        }
      } catch (error) {
        console.log('%c 🍌 error: ', 'font-size:20px;background-color: #E41A6A;color:#fff;', error);
      }
    },
    goInterLink({ columnType, id, name, href }) {
      if (href) {
        window.location.href = href
      } else if (columnType) {
        // 0 为单页 1: 列表
        this.$router.push({
          path: '/news',
          query: {
            columnName: name
          }
        })
      } else {
        this.$router.push({
          path: '/subPage',
          query: {
            name
          }
        })
      }
    }
  }
};
</script>

<style lang="less">
.side-bar-main {
  background: rgba(0, 30, 61, 0.6);
  height: 72px;
  position: absolute;
  bottom: 0;
  width: 100%;
  .nav-main {
    width: 100%;
    padding: 0 220px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    .nav-item {
      &:first-child{
        margin: 0;
      }
      &:last-child{
        margin: 0;
      }
      // margin-left:4.5px;
      flex: 0 0 auto;
      position: relative;
      display: inline-block;
      margin-right: 7px !important;
      .text {
        display: inline-block;
        padding: 0 20px;
        white-space: nowrap;
        color: rgb(255, 255, 255);
        text-decoration: none;
        transition: background 0.2s;
        font-weight: bold;
        display: inline-block;
        font: 500 18px PingFang SC;
        line-height: 72px;
      }
      .text:hover {
        background: #0060B5;
      }
      .chidren-box {
        display: none;
        list-style-type: none;
        position: absolute;
        z-index: 999;
        background: rgba(0, 0, 0, 0.6);
        .chidren-item {
          position: relative;
          display: block;
          text-align: left;
          margin: 0;
          .text {
            white-space: nowrap;
            padding-left: 15px;
            padding-right: 15px;
            color: rgb(255, 255, 255);
            text-decoration: none;
            font-size: 16px;
            line-height: 50px;
            display: inline-block;
          }
        }
      }
      &:hover .chidren-box {
        display: block;
      }
    }
  }

  li {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    color: #fff;
    font: normal 16px 微软雅黑, Arail, Verdana;
    text-decoration: none;
    line-height: 50px;
  }
  // .el-menu--horizontal {
  //   background: #367dbe;
  //   border-bottom: none;
  // }
  // .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  //   background: #367dbe;
  //   color: #fff;
  // }
  .background-color {
    color: #fff;
  }
  // .el-submenu__title {
  //   color: #fff;
  // }
  // .el-submenu__title:hover {
  //   background: rgba(255, 255, 255, 0.6);
  // }
  // .el-menu--horizontal > .el-menu-item {
  //   height: 56px;
  //   border-bottom: none;
  // }
  // .el-menu-item:hover {
  //   background: rgba(255, 255, 255, 0.6);
  //   color: #fff;
  // }
  // .el-menu-item {
  //   color: #fff;
  // }
}
</style>
